<div class="dashboard">
  <div class="dashboard-content">

    @if (chatNotFound) {
      <p class="chat-not-found" role="status">
        <mat-icon>info</mat-icon>
        {{ 'colimind.chatNotFound' | translate }}
      </p>
    }

    <div class="greeting">
      <p class="greeting-text">
        {{ greetingText() }} {{ userName }}
      </p>
      <h1 class="greeting-title" [innerHTML]="greetingTitle()">
      </h1>
    </div>

    <div class="chat-input-box" [class.chat-input-box--cue]="highlightInput">
      <textarea
        #inputEl
        [(ngModel)]="input"
        name="question"
        rows="2"
        [placeholder]="'colimind.inputPlaceholder' | translate"
        autocomplete="off"
        (keydown.enter)="$event.preventDefault(); submit()"
        (input)="autoResize($event)"
        class="chat-input-textarea"
      ></textarea>
      <div class="chat-input-actions">
        <button
          type="button"
          class="chat-input-submit"
          [disabled]="!input.trim()"
          (click)="submit()"
          >
          <mat-icon>arrow_upward</mat-icon>
        </button>
      </div>
    </div>

    @if (alertBannerAvailable) {
      <div class="alert-banner" (click)="onAlertBanner()">
        <div class="alert-badge">
          <mat-icon>assignment_late</mat-icon>
        </div>
        <div>
          <p class="alert-title">{{ 'colimind.alertTitle' | translate }}</p>
          <p class="alert-action">{{ 'colimind.alertAction' | translate }}</p>
        </div>
      </div>
    }

    <div class="quick-actions">
      @for (action of quickActions; track action.id) {
        <mat-card
          class="quick-action-card"
          (click)="onQuickAction(action)"
          >
          <div class="quick-card-body">
            <div class="quick-icon-badge" [ngClass]="action.iconBgClass">
              <mat-icon [ngClass]="action.iconColorClass">{{ action.icon }}</mat-icon>
            </div>
            <p class="quick-title">{{ action.titleKey | translate }}</p>
            <p class="quick-desc">{{ action.descKey | translate }}</p>
          </div>
        </mat-card>
      }

      @for (sug of suggestions; track sug) {
        <mat-card
          class="quick-action-card"
          (click)="send.emit(sug.instruction)"
          >
          <div class="quick-card-body">
            <div class="quick-icon-badge qa-badge--gray">
              <mat-icon class="qa-icon--gray">lightbulb</mat-icon>
            </div>
            <p class="quick-title">{{ sug.title }}</p>
            <p class="quick-desc">{{ sug.instruction }}</p>
          </div>
        </mat-card>
      }
    </div>

    @if (debug.enabled()) {
      <div class="demo-section">
        <p class="demo-label">{{ 'colimind.widgetDemos' | translate }}</p>
        <mat-chip-set>
          @for (pill of demoPills; track pill) {
            <mat-chip
              (click)="onDemoPill(pill)"
              class="demo-chip"
              >
              {{ pill.label }}
            </mat-chip>
          }
        </mat-chip-set>
      </div>
    }

  </div>
</div>
